import { getToken, RULES_API } from "../util/auth";

const BASE = RULES_API;

type ReferenceValuesPayload = {
  profile_id: string;
  profile_name: string;
  rule_set: string;
  owner_username: string | null;
  updated_at: string | null;
  values: Record<string, any>;
};

type ReferenceValuesExportPayload = {
  type: string;
  version: number;
  exported_at: string;
  profile: ReferenceValuesPayload;
};

const buildHeaders = () => {
  const token = getToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

export async function getReferenceValues() {
  const res = await fetch(`${BASE}/ref-values/me`, {
    method: "GET",
    headers: buildHeaders(),
  });

  if (!res.ok) throw new Error(await res.text());

  const payload = (await res.json()) as {
    ok: boolean;
    data: ReferenceValuesPayload;
  };

  return payload.data;
}

export async function saveReferenceValues(values: Record<string, any>) {
  const res = await fetch(`${BASE}/ref-values/me`, {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify({ values }),
  });

  if (!res.ok) throw new Error(await res.text());

  const payload = (await res.json()) as {
    ok: boolean;
    data: ReferenceValuesPayload;
  };

  return payload.data;
}

export async function exportReferenceValues() {
  const res = await fetch(`${BASE}/ref-values/me/export`, {
    method: "GET",
    headers: buildHeaders(),
  });

  if (!res.ok) throw new Error(await res.text());

  const payload = (await res.json()) as {
    ok: boolean;
    data: ReferenceValuesExportPayload;
  };

  return payload.data;
}

export async function importReferenceValues(payload: Record<string, any>) {
  const res = await fetch(`${BASE}/ref-values/me/import`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify({ payload }),
  });

  if (!res.ok) throw new Error(await res.text());

  const response = (await res.json()) as {
    ok: boolean;
    data: ReferenceValuesPayload;
  };

  return response.data;
}
